export { default } from './MainBanner';
